'use strict';Object.defineProperty(exports,'__esModule',{value:true});exports.getVersionString = getVersionString;var VERSION='2.9.3';function getVersionString(){return VERSION;}
//# sourceMappingURL=Version.js.map
